import type { ReactElement, SVGProps } from 'react'

import LogoMark from '@/assets/brand/corvinus-logo.svg?react'
import Lockup from '@/assets/brand/corvinus-lockup.svg?react'
import { cn } from '@/lib/utils'

type LogoProps = Omit<SVGProps<SVGSVGElement>, 'title'> & {
  /** Accessible name; omit to render the mark as decorative. */
  title?: string
}

/**
 * Raven mark with the base bar — Figma `corvinus-logo`, 47 × 64.
 * Fills use `currentColor`, so the mark follows the theme.
 */
export function CorvinusMark({ className, title, ...props }: LogoProps): ReactElement {
  return (
    <LogoMark
      role="img"
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      className={cn('text-icon h-[64px] w-[47px]', className)}
      {...props}
    />
  )
}

/**
 * Full logo lockup (mark + "Corvinus University of Budapest") —
 * Figma `corvinus-logo`, 140 × 50.
 */
export function CorvinusLockup({ className, title, ...props }: LogoProps): ReactElement {
  return (
    <Lockup
      role="img"
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      className={cn('text-icon h-[50px] w-[140px]', className)}
      {...props}
    />
  )
}
